import { isFeatureEnabledFromConfig } from "./featureFlags";

/** @type {string} Tenant feature flag for leg power unit / trailer fields. */
export const LEG_FLEET_EQUIPMENT_FEATURE_KEY =
  "jobs.legs.fleetEquipment.enabled";

/**
 * Whether leg fleet equipment (power unit + trailer) is enabled for this tenant.
 * Opt-in only: must be explicitly true in resolved feature flags.
 *
 * @param {object} [configs]
 * @returns {boolean}
 */
export function isLegFleetEquipmentEnabled(configs = {}) {
  return isFeatureEnabledFromConfig(configs, LEG_FLEET_EQUIPMENT_FEATURE_KEY);
}

/**
 * Normalize leg equipment fields for API payloads.
 *
 * @param {object} formValues
 * @param {{ enabled?: boolean }} [options]
 * @returns {{ powerUnit: string|null, trailer: string|null }}
 */
export function normalizeLegEquipmentPayload(formValues = {}, options = {}) {
  const enabled =
    options.enabled === undefined ? true : Boolean(options.enabled);

  if (!enabled) {
    return { powerUnit: null, trailer: null };
  }

  const powerUnit = formValues.powerUnit;
  const trailer = formValues.trailer;
  return {
    powerUnit: powerUnit?._id || powerUnit || null,
    trailer: trailer?._id || trailer || null,
  };
}

/**
 * @param {object|undefined|null} unit
 * @returns {string|null}
 */
export function resolveEquipmentId(unit) {
  if (!unit) return null;
  if (typeof unit === "string") return unit;
  return unit._id || null;
}
